import React from 'react';
export function CampaignAbTestIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1a1 1 0 011 1v1h8a1 1 0 011 1v10a1 1 0 01-1 1h-8v1a1 1 0 11-2 0v-1H3a1 1 0 01-1-1V4a1 1 0 011-1h8V2a1 1 0 011-1zm-1 4H4v8h7V5zm2 8h7V5h-7v8zm1-6a1 1 0 011-1h3a1 1 0 011 1v4a1 1 0 01-1 1h-3a1 1 0 01-1-1V7zm6.64 9.231a1 1 0 01.129 1.408l-3.326 4a1 1 0 01-1.535.003l-1.675-2a1 1 0 111.534-1.284l.905 1.081 2.559-3.078a1 1 0 011.408-.13zm-17.347.062a1 1 0 011.414 0L6 17.586l1.293-1.293a1 1 0 011.414 1.414L7.414 19l1.293 1.293a1 1 0 11-1.414 1.414L6 20.414l-1.293 1.293a1 1 0 01-1.414-1.414L4.586 19l-1.293-1.293a1 1 0 010-1.414z"
  }));
}